import React, { useEffect, useState } from 'react'
import MainLayout from '../../containers/MainLayout'
import Loader from '../../baseComponents/Loader'
import PageTitle from '../../baseComponents/PageTitle'
import ReCaptchaV2 from 'react-google-recaptcha'

import { Link } from 'react-router-dom'

import { getContactInfo, sendForm } from '../../services/contact'
import { getURLByRouteName } from '../../utils/routes'
import { connect } from 'react-redux'
import { langTexts } from './locals'

import titleLogo from '../../assets/images/title-icons/Location-Line.svg'
import { ReactComponent as Logo } from '../../assets/images/title-icons/Location-Line.svg'
import phoneLogo from '../../assets/images/title-icons/Phone-Line.png'
import reportLogo from '../../assets/images/title-icons/View-Line.png'

import './index.css'


const Contact = props => {
  const { lang } = props.settings
    , texts = langTexts[lang]

  const [isFetching, setIsFetching] = useState(true)
    , [activeClass, setActiveClass] = useState('')
    , [fullname, setFullname] = useState('')
    , [subject, setSubject] = useState('')
    , [email, setEmail] = useState('')
    , [comments, setComments] = useState('')
    , [error, setError] = useState('')
    , [captchaCompleted, setCaptchaCompleted] = useState(false)
    , [termsAccepted, setTermsAccepted] = useState(false)
    , [isSending, setIsSending] = useState(false)
    , [isSuccess, setIsSuccess] = useState(false)
    , [data, setData] = useState({})


  useEffect(() => {
    let timeout = null
    getContactInfo()
      .then(res => {
        setData(res)
        setIsFetching(false)
        timeout = setTimeout(() => {
          setActiveClass('active')
        }, 500)
      })
      .catch(err => console.log(err))

    return () => {
      clearTimeout(timeout)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (isFetching) return <Loader />

  let info = data[lang]
    , mainPhoneNumbers = info.mainPhoneNumbers ? info.mainPhoneNumbers : []
    , emailReport = info.emailReport ? info.emailReport : []
    , secondaryPhoneNumbers = info.secondaryPhoneNumbers ? info.secondaryPhoneNumbers : []
    , title = info.title ? info.title : texts.title
    , label = info.titleRedLabel ? info.titleRedLabel : ''

  const renderText = message => {
    let urlPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/gim
    message = message.replace(urlPattern, url => `<a href="mailto:${url}">${url}</a>`)
    message = message.replace(/\n/gim, br => `</br>`)

    return `<span>${message}</span>`
  }

  const onClick = () => {
    setError('')
    if (
      !fullname.trim().length ||
      !subject.trim().length ||
      !email.trim().length ||
      !comments.trim().length
    ) {
      setError(texts.allRequired)
    } else {
      const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/gim
      if (!emailRegex.test(email)) return setError(texts.invalidEmail)
      if (!termsAccepted) return setError(texts.termsRequired)
      if (!captchaCompleted) return setError(texts.captchaIncompleted)
      setIsSending(true)

      sendForm(fullname, email, subject, comments, termsAccepted)
        .then(res => {
          setIsFetching(false)
          setIsSuccess(true)
        })
        .catch(err => {
          console.log(err)
          setIsSending(false)
          setError(texts.err)
        })
    }
  }


  if (!Boolean(props.general.recaptcha_public_v2)) return null

  return <MainLayout id='contact' className={`${activeClass}`} logo={<Logo />}>
    <PageTitle title={title} label={label} logo={titleLogo} />
    <div className='map__container'>
      <div id='sanfer-map' className='transition'>
        <iframe
          title='Sanfer mapa'
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3764.3395221940787!2d-99.20175598518105!3d19.354446086928757!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d1ff5be204b855%3A0xae55a386e542f8e1!2sLaboratorios%20Sanfer%20S.A.%20de%20C.V.!5e0!3m2!1ses-419!2smx!4v1628696067016!5m2!1ses-419!2smx"
          loading="lazy"></iframe>
      </div>
      <div className='contact__block transition'>
        <div className='contact__container box-shadow'>
          <div className='contact__banner' style={{ background: `url(${info.cover})` }} />
          <div className='contact__card transition'>
            <div className='contact__main-contact'>
              <div className='contact__title'>
                <img src={phoneLogo} className='title-logo' alt='search' />
                <h3>{texts.phones}</h3>
              </div>
              {
                mainPhoneNumbers.map((phone, index) => <div key={index}>
                  <p><b>{phone.title}</b> </p>
                  <p>{phone.phone}</p>
                  {phone.description ? <p>{phone.description}</p> : null}
                </div>)
              }
            </div>
            <div className='contact__secondary-contact'>
              <div className='contact__title'>
                <img src={reportLogo} className='title-logo  transition' alt='search' />
                <h3>{texts.report}</h3>
              </div>

              <p >{texts.reportDesc}</p>

              <Link to={`${getURLByRouteName('pharmacovigilance')}#contacto`} className='contact__button'>
                {texts.reportBtn}
              </Link>

              {
                emailReport.map((email, index) => <div key={index}>
                  <p><b>{email.title}</b> {email.email}</p>
                  {email.description ? <p>{email.description}</p> : null}
                </div>)
              }
              {
                secondaryPhoneNumbers.map((phone, index) => <div key={index}>
                  <p><b>{phone.title}</b></p>
                  {
                    typeof phone.phone === 'string' &&
                    phone.phone.split(',').map((text, index) => <p key={index}>{text}</p>)
                  }
                  {phone.description ? <div dangerouslySetInnerHTML={{ __html: renderText(phone.description) }} /> : null}
                </div>)
              }
            </div>
          </div>
          <div className='contact__form transition'>
            {
              isSending &&
              <div className='contact__form-loader'>
                <p>{texts.sending}</p>
                <img src={info.extras.logo} alt='SANFER LOGO' />
              </div>
            }
            {
              isSuccess &&
              <div className='contact__form-loader'>
                <p dangerouslySetInnerHTML={{ __html: info.extras.thanks }} />
                <img src={info.extras.logo} alt='SANFER LOGO' />
              </div>
            }
            <div className='contact__input-container'>
              <label>{texts.fullname} <span className='red-color'>*</span></label>
              <input type='text' value={fullname} onChange={e => setFullname(e.target.value)} />
            </div>
            <div className='contact__input-container'>
              <label>{texts.subject} <span className='red-color'>*</span></label>
              <input type='text' value={subject} onChange={e => setSubject(e.target.value)} />
            </div>
            <div className='contact__input-container'>
              <label>{texts.email} <span className='red-color'>*</span></label>
              <input type='text' value={email} onChange={e => setEmail(e.target.value)} />
            </div>
            <div className='contact__input-container'>
              <label>{texts.comments} <span className='red-color'>*</span></label>
              <textarea value={comments} onChange={e => setComments(e.target.value)} />
            </div>
            <div className='contact__input-agreement'>
              <input value={termsAccepted} onChange={() => setTermsAccepted(!termsAccepted)} id='agreement' type='checkbox' />
              <label htmlFor='agreement'>
                <span>{texts.terms}</span> <Link to={getURLByRouteName('noticeOfPrivacy')}>{texts.privacy}</Link> <span className='red-color'>*</span>
              </label>
            </div>
            <div className='contact__form-send'>
              <ReCaptchaV2 sitekey={props.general.recaptcha_public_v2} onChange={() => setCaptchaCompleted(true)} />
              <span className='contact__button' onClick={onClick}>
                {texts.send}
              </span>
            </div>
            <p className='red-color'>{error}</p>
          </div>
        </div>
        <div />
      </div>
    </div>
  </MainLayout>
}

const mapStateToProps = state => ({
  settings: state.settings,
  general: state.general
})

export default connect(mapStateToProps)(Contact)
